import React from 'react'
import { DashboardCardProps } from './DashboardCard.types'
import styles from './DashboardCard.module.scss'
import cl from 'classnames'
import { H2, HorizontalLine, Numbers, SectionContainer, Text1 } from 'components/shared'
import { getIconByNotificationType, useDisplayData, useMaxWidthCorrection } from './DashboardCard.utils'
import { LoadingSpinner } from 'components'
import { NotificationType } from 'models'

const DashboardCardComponent = (props: DashboardCardProps) => {
  const {
    className,
    style,
    apiUrl,
    apiType,
    totalIsMainValue,
    valueSuffix,
    icon: Icon,
    label
  } = props

  const { displayData, isLoading } = useDisplayData(apiUrl, apiType, totalIsMainValue)
  const containerRef = useMaxWidthCorrection()

  return (
    <SectionContainer
      ref={containerRef}
      className={cl(styles.container, className)}
      style={style}
    >
      {isLoading
        ? (
          <LoadingSpinner
            show
            noBackground
            color={styles.primary}
            containerStyleProps={{
              className: styles.loadingSpinner
            }}
          />
        )
        : (
          <>
            <div className={styles.header}>
              <Icon className={styles.icon} />
              <H2
                bold
                overflowEllipsis
                style={{ marginLeft: 15 }}
              >
                {label}
              </H2>
            </div>

            <div className={styles.body}>
              <div className={styles.valueLine}>
                <H2 className={styles.value}>
                  {displayData?.value}
                </H2>
                <H2
                  overflowEllipsis
                  style={{ marginLeft: 10 }}
                >
                  {valueSuffix}
                </H2>
              </div>
              <div className={styles.valueLine}>
                <Numbers
                  className={cl(styles.valueSecondary, {
                    [styles.colorPrimary]: displayData?.valueSecondaryPrimaryColor
                  })}
                >
                  {displayData?.valueSecondary}
                </Numbers>
              </div>
            </div>

            {displayData?.notifications && (
              <>
                <HorizontalLine style={{ margin: '8px 0' }} />
                {Object.entries(displayData.notifications)
                  .map(([type, count]) => {
                    const Icon = getIconByNotificationType(type as NotificationType)
                    return (
                      <div key={type} className={styles.footer} >
                        <div className={styles.infoMark}>
                          <Icon />
                          <Text1>{count} {type.toLowerCase()}{count > 1 ? 's' : ''}</Text1>
                        </div>
                      </div>
                    )
                  })}
              </>
            )}

          </>
        )
      }
    </SectionContainer >
  )
}

const DashboardCard = DashboardCardComponent
export { DashboardCard }
